import CalendarHeader from '../components/layout/CalendarHeader';
import CalendarFooter from '../components/layout/CalendarFooter';

export interface LayoutCalendarProps {
  children: React.ReactNode;
}

const CalendarPage: React.FC<LayoutCalendarProps> = ({ children }) => (
  <>
    <CalendarHeader />
    <main>{children}</main>
    <CalendarFooter />
  </>
);
 
export default CalendarPage;